<template>
  <div v-if="posterImageStatus" class="poster-first">
    <div class="poster-pop" v-show="!canvasStatus && posterImage">
      <img
        src="@assets/images/poster-close.png"
        class="close"
        @click="posterImageClose"
      />
      <img
        :src="posterImage"
        ref="conf0"
        alt="tp"
        class="poster-image"
        id="scream"
      />
      <div class="keep">长按图片可转发给朋友或者保存到手机</div>
    </div>
    <div class="mask" @touchmove.prevent @click="posterImageClose">
      <div class="canvasBox">
        <canvas ref="myCanvas"></canvas>
        <canvas ref="avatar" width="185" height="185"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StorePoster",
  props: {
    posterImageStatus: Boolean,
    posterData: Object
  },
  data: function() {
    return {
      canvasStatus: false,
      posterImage: ""
    };
  },
  watch: {
    posterImageStatus: function() {
      let that = this;
      if (that.posterImageStatus === true) {
        that.$nextTick(function() {
          that.savePosterPath();
        });
      }
    }
  },
  mounted: function() {},
  methods: {
    posterImageClose: function() {
      this.posterImageStatus = false;
      this.canvasStatus = false;
      this.$emit("setPosterImageStatus");
    },
    savePosterPath: function() {
      this.$dialog.loading.open();
      this.setHtml2Canvas();
    },
    roundedRect(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x, y + radius);
      ctx.lineTo(x, y + height - radius);
      ctx.arcTo(x, y + height, x + radius, y + height, radius);
      ctx.lineTo(x + width - radius, y + height);
      ctx.arcTo(x + width, y + height, x + width, y + height-radius, radius);
      ctx.lineTo(x + width, y + radius);
      ctx.arcTo(x + width, y, x + width - radius, y, radius);
      ctx.lineTo(x + radius, y);
      ctx.arcTo(x, y, x, y + radius, radius);
    },
    setHtml2Canvas: function() {
      var c = this.$refs.myCanvas;
      var ctx = c.getContext("2d");

      let H = 670;
      let W = 450;
      let margin = 23;
      let topmargin = 90;
      let padding = 12

      c.width = W;
      c.height = H;
      c.style.width = W + "px";
      c.style.height = H + "px";

      ctx.fillStyle = '#fb4252';
      ctx.fillRect(0,0,W,H);

      ctx.fillStyle = "#ffffff";
      this.roundedRect(ctx, margin, topmargin, W-margin*2, H-topmargin-margin, padding);
      ctx.fill();
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.moveTo(margin + 27, topmargin);
      ctx.lineTo(margin + 34, topmargin-10);
      ctx.lineTo(margin + 41, topmargin);
      ctx.fill();

      let gap = 6;
      let radius = (topmargin-10-gap*3)/2;
      let centerY = topmargin-10-gap-radius;
      let centerX = margin+34;
      var avatar = new Image();
      avatar.onload = function() {
        ctx.save();
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(avatar, centerX-radius, centerY-radius, radius*2, radius*2);
        ctx.restore();
      }
      avatar.src = this.posterData.avatar;

      ctx.font = "22px Arial";
      ctx.fillStyle = "#ffffff";
      ctx.fillText(this.posterData.nickname, centerX+radius + 10, centerY-10);
      ctx.font = "16px Arial";
      ctx.fillStyle = "#ffffff";
      ctx.fillText("分享了一个好东西给你，快来看看吧 ^_^", centerX+radius+10, centerY+radius-9);

      var img = new Image();
      let imgX = W - (margin + padding) * 2;
      let imgY = imgX - 30;
      img.onload = function() {
        ctx.drawImage(img, margin+padding, topmargin+padding, imgX, imgY);
        ctx.beginPath();
        let r = 10;
        let color = "#ffffff";
        ctx.moveTo(margin+padding, topmargin+padding+imgY-r);
        ctx.lineTo(margin+padding, topmargin+padding+imgY);
        ctx.lineTo(margin+padding+r, topmargin+padding+imgY);
        ctx.quadraticCurveTo(margin+padding, topmargin+padding+imgY, margin+padding, topmargin+padding+imgY-r);
        ctx.fillStyle = color;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(margin+padding, topmargin+padding+r);
        ctx.lineTo(margin+padding, topmargin+padding);
        ctx.lineTo(margin+padding+r, topmargin+padding);
        ctx.quadraticCurveTo(margin+padding, topmargin+padding, margin+padding, topmargin+padding+r);
        ctx.fillStyle = color;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(margin+padding+imgX, topmargin+padding+imgY-r);
        ctx.lineTo(margin+padding+imgX, topmargin+padding+imgY);
        ctx.lineTo(margin+padding+imgX-r, topmargin+padding+imgY);
        ctx.quadraticCurveTo(margin+padding+imgX, topmargin+padding+imgY, margin+padding+imgX, topmargin+padding+imgY-r);
        ctx.fillStyle = color;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(margin+padding+imgX, topmargin+padding+r);
        ctx.lineTo(margin+padding+imgX, topmargin+padding);
        ctx.lineTo(margin+padding+imgX-r, topmargin+padding);
        ctx.quadraticCurveTo(margin+padding+imgX, topmargin+padding, margin+padding+imgX, topmargin+padding+r);
        ctx.fillStyle = color;
        ctx.fill();
      };
      img.src = this.posterData.image;
      ctx.font = "22px PingFang-SC-Medium";
      ctx.fillStyle = "#282828";
      var str = this.posterData.title;
      var titleY = topmargin + padding + imgY + 50;
      let fontWidth = ctx.measureText(str).width;
      this.canvasTextAutoLine(str, c, margin+padding, titleY, 35, W - 85, 1);
      ctx.font = "20px PingFang-SC-Heavy";
      ctx.fillStyle = "#DF2D0A";
      let priceY = titleY + 55;
      ctx.fillText("抢购价：", margin+padding, priceY+28);
      ctx.font = "36px PingFang-SC-Heavy";
      ctx.fillStyle = "#DF2D0A";
      ctx.fillText("￥" + parseFloat(this.posterData.price), margin+padding+70, priceY+28);

      var screamsCode = new Image();
      let codeY = titleY + 20;
      screamsCode.onload = function() {
        ctx.drawImage(screamsCode, 450-(margin+padding+115), codeY, 115, 115);
      };
      screamsCode.src = this.posterData.code;
      ctx.font = "14px Arial";
      ctx.fillStyle = "#282828";
      ctx.textAlign = "left";
      let fontY = codeY + 110;
      ctx.fillText("长按识别二维码 立即购买", W-margin-padding-115-160, fontY - 5);
      setTimeout(() => {
        this.posterImage = c.toDataURL();
        this.$dialog.loading.close();
      }, 500);
    },
    /**
     * str:要绘制的字符串
     * canvas:canvas对象
     * initX:绘制字符串起始x坐标
     * initY:绘制字符串起始y坐标
     * lineHeight:字行高，自己定义个值即可
     * canvasWidth:文本宽度
     * lines: 行数
     */
    canvasTextAutoLine(
      str,
      canvas,
      initX,
      initY,
      lineHeight,
      canvasWidth,
      lines
    ) {
      var ctx = canvas.getContext("2d");
      var lineWidth = 0;
      var lastSubStrIndex = 0;
      var beginLineHeight = lineHeight;
      var beginY = initY;
      for (let i = 0; i < str.length; i++) {
        lineWidth += ctx.measureText(str[i]).width;
        if (lineWidth > canvasWidth - initX) {
          //减去initX,防止边界出现的问题
          /*if (initY >= beginY + beginLineHeight * (lines - 1)) {
            ctx.fillText(
              str.substring(lastSubStrIndex, i - 1) + "...",
              initX,
              initY
            );
            return;
          } else {*/
            ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY);
            initY += lineHeight;
            lineWidth = 0;
            lastSubStrIndex = i;
          /*}*/
        }
        if (i == str.length - 1) {
          ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY);
        }
      }
    }
  }
};
</script>
<style scoped>
.poster-first .mask {
  z-index: 1001 !important;
}
.canvasBox {
  width: 100%;
  height: 100%;
  margin: auto;
  /*display: flex;*/
  flex-direction: column;
  justify-content: center;
  align-items: center;

  display: none;
}
.poster-first {
  overscroll-behavior: contain;
}
.poster-pop {
  width: 4.8rem;
  position: fixed;
  left: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  z-index: 9999;
  top: 50%;
  margin-left: -2.4rem;
}
.poster-pop .canvas {
  background-color: #ffffff;
  width: 100%;
}
.poster-pop .poster-image {
  width: 100%;
  display: block;
}
.poster-pop .canvas .image {
  width: 100%;
  height: 4.5rem;
  display: block;
}
.poster-pop .canvas .text {
  text-align: center;
  margin-top: 0.32rem;
}
.poster-pop .canvas .text.black {
  padding: 0 0.1rem;
  color: #000;
}
.poster-pop .canvas .text.rad {
  color: #ff0000;
}
.poster-pop .canvas .code {
  padding: 0 0.1rem 0.2rem 0.1rem;
}
.poster-pop .canvas .code .code-img {
  width: 1.7rem;
  height: 1.7rem;
}
.poster-pop .canvas .code .code-img img {
  width: 100%;
  height: 100%;
}
.poster-pop .canvas .code .code-text {
  width: 2.8rem;
  font-size: 0.24rem;
}
.poster-pop .close {
  width: 0.46rem;
  height: 0.75rem;
  position: fixed;
  right: 0;
  top: -0.75rem;
  display: block;
}
.keep {
  color: #fff;
  text-align: center;
  font-size: 0.25rem;
  margin-top: 0.1rem;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
}
img {
  border: none;
}
</style>
